import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { catchError, map, of, switchMap } from 'rxjs';
import { CommonConstants } from 'src/app/shared/constants/common-constants';
import { CompanyInfo, ConfigurationFunctionService } from '../services/configurationapi/configurationfunctionapi.services';
import { ShellService } from '../services/shell.service';
import { ToastrService } from 'ngx-toastr';
import { CommonFunctions } from 'src/app/shared/utilities/common-functions';
import { IamWrapperService } from '../services/iam-wrapper.service';
import { CompanyModel, ScreenUser } from '../models/u2-api-usermodels';

export const AuthGuard: CanActivateFn = () => getAuthStatus();

const getAuthStatus = (
  commonFunctions = inject(CommonFunctions),
  configApiService = inject(ConfigurationFunctionService),
  iamWrapperService = inject(IamWrapperService),
  shellService = inject(ShellService),
  toastr = inject(ToastrService),
) => configApiService.getFeaturesByApplicationAndAllCompanies(CommonConstants.U2ApplicationName).pipe(
  map((companyAgnosticConfigs: CompanyInfo) => {
    shellService.setCompanyAgnosticConfigsInSessionStorage(companyAgnosticConfigs);
  }),
  switchMap(() => iamWrapperService.getUserAccessedCompaniesAndScreenPermissions().pipe(
    map((response: { screenPermissions: ScreenUser; companyData: CompanyModel[] }) => {
      if (!response?.companyData?.length || !response?.screenPermissions?.roles?.length) {
        commonFunctions.hideLoading();
        shellService.setNoAccess(true);
        return false;
      }
      shellService.setCompanyDataInSessionStorage(response);
      return true;
    })
  )),
  catchError((error) => {
    commonFunctions.hideLoading();
    shellService.setNoAccess(true);
    commonFunctions.handleErrorResponse(error, toastr, CommonConstants.UnableToLoadData);
    return of(false);
  })
);
